export let estadoCuenta=(valor)=>{ return {type:"ESTADO",payload:valor} };
export let consolaCuenta=(valor)=>{ return {type:"CONSOLAS",payload:valor} };
export let accountFilter=(valor)=>{ return {type:"ACCOUNT_FILTER",payload:valor} };
